import BasicButton from "../../common/components/BasicButton";
import LabeledInput from "../../common/components/LabeledInput";
import Modal from "../../common/components/Modal";
import { useUpdateReportReasonModal } from "./UpdateReportReasonModal.hook";
import Loader from "../../common/components/Loader";
import {
  ReportReason,
  ReportReasonType,
} from "../../../lib/apollo/graphql/generated";
import SelectBox from "../../common/components/SelectBox";

interface AddReportReasonModalProps {
  isOpen: boolean;
  onClose: () => void;
  reportReason: ReportReason | null;
}

export default function AddReportReasonModal({
  isOpen,
  onClose,
  reportReason,
}: AddReportReasonModalProps) {
  const {
    models: { form, loading, isSubmitDisabled },
    operations: { onChange, onSubmit },
  } = useUpdateReportReasonModal(onClose, reportReason);

  return (
    <Modal open={isOpen} onClose={onClose} title="신고사유 추가" height="700px">
      <form className="flex h-full w-full flex-col gap-5" onSubmit={onSubmit}>
        <LabeledInput
          label="아이디"
          value={form.id}
          placeholder="(아이디 생성 예정)"
          disabled
        />
        <LabeledInput
          label="신고사유"
          value={form.reason}
          onChange={(event) => onChange("reason", event.target.value)}
        />
        <div className="flex w-1/2 flex-col">
          <p className="text-lg font-bold">종류</p>
          <SelectBox
            value={form.type}
            onSelect={(value) => onChange("type", value)}
            options={[
              {
                label: "게시물 신고",
                value: ReportReasonType.CaregiverCommunity,
              },
              {
                label: "게시물 댓글 신고",
                value: ReportReasonType.CaregiverCommunityReply,
              },
              {
                label: "정보글 신고",
                value: ReportReasonType.CaregiverInfoReply,
              },
              { label: "사용자 차단", value: ReportReasonType.Caregiver },
            ]}
            className="h-[50px]"
          />
        </div>
        <SelectBox
          label="상태"
          value={form.active}
          onSelect={(value) => onChange("active", value)}
          options={[
            {
              label: "활성",
              value: "ACTIVE",
            },
            {
              label: "비활성",
              value: "INACTIVE",
            },
          ]}
          className="h-[50px]"
        />
        <div className="mt-auto w-1/2 self-center">
          <BasicButton
            type="submit"
            text={`${reportReason ? "수정" : "추가"}`}
            icon={loading && <Loader />}
            className="w-full"
            disabled={isSubmitDisabled}
          />
        </div>
      </form>
    </Modal>
  );
}
